import { render, staticRenderFns } from "./PlatformInvoiceTab.vue?vue&type=template&id=5f7b04ba&scoped=true"
import script from "./PlatformInvoiceTab.vue?vue&type=script&lang=js"
export * from "./PlatformInvoiceTab.vue?vue&type=script&lang=js"
import style0 from "./PlatformInvoiceTab.vue?vue&type=style&index=0&id=5f7b04ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7b04ba",
  null
  
)

export default component.exports